module.exports = __webpack_public_path__ + "img/4-3-1-2-1-preview-guests1-e.2edbf6b1.jpg";